import DatePicker from 'material-ui/DatePicker';
import RaisedButton from 'material-ui/RaisedButton';
import {
    Step,

    StepLabel, Stepper
} from 'material-ui/Stepper';
import ArrowForwardIcon from 'material-ui/svg-icons/navigation/arrow-forward';
import TextField from 'material-ui/TextField';
import React, { Component } from 'react';
import Recaptcha from 'react-recaptcha';
import { connect } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import answerimg from '../../images/answer.png';
import creditcardlogo from '../../images/credit-cards-vector-icon-.jpg';
import s from '../../services/allservices.jsx';
import GusetNavbar from '../navigation/guestnavbar.jsx';
import DefaulNavbar from '../navigation/defaultnavbar.jsx';
import { getClientId, getClientSecret, buildClientHeader } from "../../../src/utils/clientAuth.js";
import uuidv4 from 'uuid/v4';
import SuccessPopup from '../secretqbutton/secretqbutton.jsx';
import OtpPopup from '../otp/OtpPopup.js';
import { withRouter } from 'react-router-dom';
const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};

const mapStateToProps = state =>
({
    userIdState: state.getuseridReducer.userIdState,
    cardNumber: state.stoteCardDetail.cardNumber,
    publicKey: state.publicKey.publicKey
})
const mapDispatchToProps = dispatch =>
({
    fetchUserid(cardNumber) {
        dispatch(
            actions.getUseridAction(cardNumber)
        )
    }
})
var callback = function () {

};

// specifying verify callback function

let recaptchaInstance;
const resetRecaptcha = () => {
    recaptchaInstance.reset()
}
const JSEncrypt = window.JSEncrypt
class ForgotUserId extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepIndex: 0,
            response: "",
            cardNumber: '',
            secretQuestionAnswer: '',
            secretQuestionCode: '',
            secretQuestionDescription: '',
            emailId: '',
            mobileNumber: '',
            secretPassword: '',
            accountId: '',
            applicationId: '',
            disabled: true,
            disableduser: true,
            showResetPopup: false,
            popupMessage: "",
            otpOpen: false,
            otp: "",

            popupLoader: false,
        }
        this.otpPopupOpenModal = this.otpPopupOpenModal.bind(this);
        this.otpPopupCloseModal = this.otpPopupCloseModal.bind(this);
    }

    handleGoback(e) {
        // localStorage.clear();
        // this.props.history.push("/login")
        const pform = localStorage.getItem("pform");

        localStorage.clear();

        if (pform) {
            localStorage.setItem("pform", pform);
        }

        this.props.history.push("/login");
    }

    onChange = (e, value) => this.setState({ [e.target.name]: value }, () => {
        if (this.state.cardNumber.length !== 0) {
            this.setState({
                disabled: false
            })
        }
        else {
            this.setState({
                disabled: true
            })
        }
    })
    handleDate = (e, date) => {
        this.setState({
            secretPassword: this.converDate(date),
            dateSelected: true
        })
    }
    converDate(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
        ].join('-');
    }
    formatDate = (date) => {
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        return `${(day < 10) ? ('0' + day) : day}/${(month < 10) ? ('0' + month) : month}/${year}`
    }
    handleAnswer = (e, value) => this.setState({ [e.target.name]: value }, () => {
        if (this.state.secretPassword.length !== 0 && this.state.response.length !== 0) {
            this.setState({
                disableduser: false
            })
        }
        else {
            this.setState({
                disableduser: true
            })
        }
    })

    verifyCallback = response => {
        this.setState({
            response: response
        }, () => {
            if (this.state.secretPassword.length !== 0 && this.state.response.length !== 0) {
                this.setState({
                    disableduser: false
                })
            }
            else {
                this.setState({
                    disableduser: true
                })
            }
        })
    }
    expiredCallback = response => {
        this.setState({
            disableduser: true
        })

    }
    handelSecretAnswer = (onSuccess, onError) => {

        const { response } = this.state
        const { publicKey } = this.props

        this.setState({
            disableduser: true
        })

        let _this = this
        if (response !== '') {
            if (publicKey && publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);

                const state = {
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    secretPassword: encrypt.encrypt(this.state.secretPassword),
                    accountId: encrypt.encrypt(this.state.accountId),
                    secretQuestionCode: encrypt.encrypt(this.state.secretQuestionCode),
                    otp: this.state.otp
                }
                let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                let gid = getClientId();
                fetch(plink + s.send_userid + "/?g-recaptcha-response=" + response, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'clientId': gid,
                        'clientSecret': getClientSecret(gid, this.state.accountId),
                        'X-KlickEx-Client': buildClientHeader(),
                    }),
                    body: JSON.stringify(state)
                })

                    .then(res => {
                        if (res.status === 200 || res.status === 204) {

                            toast.success(res.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            if (onSuccess) {
                                onSuccess();
                            }

                            this.otpPopupCloseModal();

                            this.setState({
                                popupLoader: false,
                                loader: true
                            });
                            setTimeout(function () {
                                _this.props.history.push('/logout');
                            }, 3000);
                        }
                        else if (res.status === 401) {

                            this.setState({
                                popupLoader: false,
                                loader: false,
                                disableduser: true
                            });

                            this.otpPopupCloseModal();

                            if (this.props.history !== undefined) {
                                this.props.history.push('/sessionout')
                            }

                        }
                        // else if (res.status === 422) {
                        //     // resetRecaptcha()
                        //     // this.otpPopupCloseModal();

                        //     this.setState({
                        //         popupLoader: false,
                        //         loader: false,
                        //     });
                        //     if (onError) {
                        //         onError(res.headers.get('message'));
                        //     }
                        //     let message = res.headers.get("message");

                        //     res.json().then((json) => {
                        //         message = json.message
                        //             ? json.message
                        //             : res.headers.get("message");

                        //         toast.error(message, {
                        //             position: "top-right",
                        //             autoClose: 3000,
                        //             hideProgressBar: false,
                        //             closeOnClick: true,
                        //             pauseOnHover: true,
                        //             draggable: true,
                        //             draggablePercent: 60,
                        //         });
                        //     });

                        //     toast.error(message, {
                        //         position: "top-right",
                        //         autoClose: 3000,
                        //         hideProgressBar: false,
                        //         closeOnClick: true,
                        //         pauseOnHover: true,
                        //         draggable: true,
                        //         draggablePercent: 60,
                        //     });

                        // }
else if (res.status === 422) {
    // resetRecaptcha()
    // this.otpPopupCloseModal();

    this.setState({
        popupLoader: false,
        loader: false,
    });
    if (onError) {
        onError(res.headers.get('message'));
    }
    let message = res.headers.get("message");

    res.json().then((json) => {
        message = json.message
            ? json.message
            : res.headers.get("message");

        toast.error(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 60,
        });
    });

    // toast.error(message, {
    //     position: "top-right",
    //     autoClose: 3000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     draggablePercent: 60,
    // });

}

                        else {
                            this.setState({
                                popupLoader: false,
                            });

                            if (onError) {
                                onError(res.headers.get('message'));
                            }
                            // toast.error(res.headers.get('message'), {
                            //     position: "top-right",
                            //     draggablePercent: 60,
                            //     autoClose: 3000,
                            //     hideProgressBar: false,
                            //     closeOnClick: true,
                            //     pauseOnHover: true,
                            //     draggable: false
                            // });
                              let message = res.headers.get("message");
                            res.json().then((json) => {
                            message = json.message
                                ? json.message
                                : res.headers.get("message");
                       
                            toast.error(message, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                draggablePercent: 60,
                            });
                            });
                            resetRecaptcha()
                            this.otpPopupCloseModal();
                            // document.getElementById("secretAnswer").value = ""
                            // document.getElementById("secretAnswer").focus()
                            this.setState({
                                disableduser: false
                            })
                        }
                    })
            }
        }
    }
    // for otp open

    otpPopupOpenModal() {
        if (!this.state.otpValidation) {

            this.setState({ otp: "", popupLoader: true }, () => {
                this.handelSecretAnswer(null, null);
            });
            return;
        }

        this.setState({
            otpOpen: true,
            popupLoader: true,
        }, () => {
            this.handleRequestOtp(false);
        });
    }

    // for otp close
    otpPopupCloseModal() {

        this.setState({
            otpOpen: false,
            popupLoader: false,
        });
    }
    handleRequestOtp = (isResend = false) => {

        const { publicKey } = this.props;

        const accountId = this.state.accountId;

        if (publicKey && publicKey.status === 200) {

            const public_Key = publicKey.body.publickey;

            let encrypt = new JSEncrypt();

            encrypt.setPublicKey(public_Key);

            let traceId = getClientId();

            let gid = getClientId();

            const payload = {

                accountId: encrypt.encrypt(accountId),

                applicationId:
                    localStorage.getItem('pform') === 'AU'
                        ? 'klickexau'
                        : 'klickex'
            };
            if (isResend) {
                payload.reSendOtp = true;
            }

            this.setState({
                loader: true
            });

            let plink =
                localStorage.getItem('pform') === 'AU'
                    ? process.env.REACT_APP_SERVICEURL_AU
                    : process.env.REACT_APP_SERVICEURL_NZ;

            fetch(plink + s.otp_get_userId, {

                method: "POST",

                headers: new Headers({

                    "Content-Type": "application/json",

                    clientId: gid,

                    clientSecret: getClientSecret(gid, accountId),

                    "X-Trace-Id": traceId,

                    "X-KlickEx-Client": buildClientHeader(),
                }),

                body: JSON.stringify(payload)

            })
                .then((response) => {

                    if (
                        response.status === 200 ||
                        response.status === 201 ||
                        response.status === 204
                    ) {

                        toast.success(response.headers.get("message"), {
                            position: "top-right",
                            autoClose: 3000,
                        });

                    }
                    else if (response.status === 401) {

                        this.setState({
                            loader: false
                        });

                        if (this.props.history !== undefined) {
                            this.props.history.push('/sessionout')
                        }

                    }
                    else {

                        toast.error(response.headers.get("message"), {
                            position: "top-right",
                            autoClose: 3000,
                        });
                    }

                    this.setState({
                        loader: false
                    });

                    return response;
                });
        }
    };
    handleOtpSubmit = (otp, onSuccess, onError) => {

        this.setState({

            otp: otp,
            popupLoader: true,

        }, () => {

            this.handelSecretAnswer(onSuccess, onError);

        });

    };
    checkUserId = () => {
        const { publicKey } = this.props
        this.setState({
            disabled: true
        })
        if (publicKey && publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);
            const state = {
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                cardNumber: encrypt.encrypt(this.state.cardNumber),
            }
            let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
            let gid = getClientId();
            let traceId = getClientId();
            fetch(plink + s.get_userid, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'clientId': gid,
                    'clientSecret': getClientSecret(gid, this.state.cardNumber),
                    'X-Trace-Id': traceId,
                    'X-KlickEx-Client': buildClientHeader(),
                }),
                body: JSON.stringify(state)
            })
                .then(res => {
                    if (res.status === 200 || res.status === 201) {
                        res.json().then(json => {
                            localStorage.setItem('emailID', json.emailId);

                            this.setState({
                                stepIndex: 1,
                                secretQuestionCode: json.secretQuestionCode,
                                secretQuestionDescription: json.secretQuestionDescription,
                                accountId: json.accountId,
                                emailId: json.emailId,
                                otpValidation: json.otpValidation
                            }, () => {

                            });
                        })
                    }

                    else if (res.status === 401) {

                        this.setState({
                            disabled: false,
                            loader: false
                        });

                        if (this.props.history !== undefined) {
                            this.props.history.push('/sessionout')
                        }

                    }

                    else if (res.status === 428) {

                        let message = res.headers.get('message');

                        this.setState({
                            showResetPopup: true,
                            popupMessage: message,
                            disableduser: false,
                            loader: false
                        });

                    }
                    else if (res.status === 422) {

                        toast.error(res.headers.get('message'), {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 60
                        });

                        this.setState({
                            disableduser: false,
                            loader: false
                        });

                    }
                    else {
                        toast.error(res.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                        this.setState({
                            disabled: true
                        })
                    }
                })
        }
    }
    getStepContent(stepIndex) {
        const { secretQuestionDescription, emailId } = this.state
        switch (stepIndex) {
            case 0:
                return (
                    <div>
                        <ToastContainer
                            draggablePercent={60}
                            position="top-right"
                            autoClose={3000}
                            hideProgressBar={false}
                            newestOnTop
                            closeOnClick
                            rtl={false}
                            pauseOnVisibilityChange
                            draggable={false}
                            pauseOnHover
                        />

                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="col-md-12" >
                                        <div className="row " style={{ padding: "12px 15px", minHeight: "100px" }} >
                                            <div>
                                                <div className="row">
                                                    <div className="header-style" style={{ padding: "5px 20px 0px 13px" }}>
                                                        <h4 className='logmainheading mainheading'>
                                                            Forgot Your User ID ?
                                                        </h4>
                                                        <p>Enter your card number to retrieve your User ID.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12" style={{ padding: "0px 15px", marginTop: "20px" }}>
                                        <div className="row  mb-3" style={{ padding: "12px 15px", minHeight: "300px" }} >
                                            <div className="summary-header">
                                                <div className="row">
                                                    {/* <div className="col-md-12">
                                                        <p>Please Enter Your Card Number</p>
                                                    </div> */}
                                                    <div className="col-md-12">
                                                        <div className="row" >
                                                            <div className="row input-group" >

                                                                <div className="col-sm-10" >
                                                                    <TextField
                                                                        hintText="Card Number"
                                                                        floatingLabelText="Card Number"
                                                                        type="text"
                                                                        name="cardNumber"
                                                                        // autoComplete='none'
                                                                        autoComplete='off'
                                                                        maxLength="16"
                                                                        className="my-className"
                                                                        onChange={this.onChange}
                                                                        underlineFocusStyle={styles.focusStyle}
                                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="row input-group text-center ml-1 pt-3" >

                                                                <RaisedButton
                                                                    label="Go Back To HomePage"
                                                                    // style={styles.button}
                                                                    className="btn-std mt-2 mr-2"
                                                                    backgroundColor="#FFCE39"
                                                                    labelColor="#115876"
                                                                    onClick={this.handleGoback.bind(this)}
                                                                    buttonStyle={{ borderRadius: 50 }}
                                                                    style={{ borderRadius: 50 }}
                                                                // icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                />

                                                                <RaisedButton
                                                                    label="Continue"
                                                                    // style={styles.button}
                                                                    className="btn-std mt-2"
                                                                    backgroundColor="#FFCE39"
                                                                    labelColor="#115876"
                                                                    disabled={this.state.disabled}
                                                                    onClick={this.checkUserId}
                                                                    buttonStyle={{ borderRadius: 50 }}
                                                                    style={{ borderRadius: 50 }}
                                                                // icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                />
                                                                <div className="col-sm-12 text-center mb-4">



                                                                </div>

                                                                {/* Popup Component */}


                                                            </div>

                                                            {/* <SuccessPopup /> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 1:
                return (
                    <div>
                        <ToastContainer
                            draggablePercent={60}
                            position="top-right"
                            autoClose={3000}
                            hideProgressBar={false}
                            newestOnTop
                            closeOnClick
                            rtl={false}
                            pauseOnVisibilityChange
                            draggable={false}
                            pauseOnHover
                        />
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="col-sm-12">
                                        <div className="col-md-12">
                                            <div className="row " style={{ padding: "12px 15px", minHeight: "100px" }} >
                                                <div>

                                                    <div className="row">
                                                        <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                                            <h4 className='logmainheading mainheading'>
                                                                Forgot Your User ID ?
                                                            </h4>
                                                            <p>Complete the following security question to retrieve your User ID.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{ padding: "0px 15px", marginTop: "20px" }}>
                                            <div className="row mb-3" style={{ padding: "12px 15px", minHeight: "100px" }} >
                                                <div>
                                                    <div className="row">
                                                        {/* <div className="col-md-12"> */}


                                                        {/* <div className="row" style={{ marginTop: "-25px",marginLeft:"15px" }}>
                                                            <div className="row">
                                                                <div className="offset-md-1 col-md-10">
                                                                    <div className="row">
                                                                        <label className="col-md-4 col-sm-12">Secret Question:  </label>
                                                                        <span className="col-md-6 col-sm-12">{secretQuestionDescription + "?"} </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                        <div
                                                            className="row align-items-center"
                                                            style={{
                                                                marginTop: "-25px",

                                                                paddingLeft: "15px",
                                                            }}
                                                        >
                                                            <div className="col-md-12 d-flex flex-wrap align-items-center">
                                                                <label
                                                                    style={{
                                                                        fontWeight: "600",
                                                                        fontSize: "16px",
                                                                        marginRight: "10px",
                                                                        color: "#222",
                                                                        marginBottom: "0",
                                                                        minWidth: "140px",
                                                                    }}
                                                                >
                                                                    Secret Question:
                                                                </label>

                                                                <span
                                                                    style={{
                                                                        fontSize: "16px",
                                                                        color: "#444",
                                                                        wordBreak: "break-word",
                                                                    }}
                                                                >
                                                                    {secretQuestionDescription}?
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="col-md-12 pl-1" >
                                                                <div className="row-fluid input-group" >
                                                                    <div className="col-sm-12 offset-sm-0 offset-md-2 pl-0" >
                                                                        {(this.state.secretQuestionCode === "DOB") ?

                                                                            <DatePicker hintText="Birthday"
                                                                                // container="inline" mode="landscape"
                                                                                openToYearSelection={true}
                                                                                floatingLabelText="Secret Answer(Date Of Birth)"
                                                                                style={{ width: "100%" }}
                                                                                type="text"
                                                                                name="secretAnswer"
                                                                                onChange={this.handleDate}
                                                                                id="secretAnswer"
                                                                                maxDate={new Date()}
                                                                                formatDate={this.formatDate}
                                                                                className="input-width required"
                                                                                // defaultValue={this.state.secretAnswerDate || null}
                                                                                // defaultDate={( new Date(this.state.secretAnswerDate))} 
                                                                                // defaultDate={ this.state.secretAnswerDate}
                                                                                defaultDate={(this.state.secretAnswerDate) ? new Date(this.state.secretAnswerDate) : this.state.secretAnswerDate}

                                                                                // defaultDate={new Date()}
                                                                                // defaultDate= {new Date()}
                                                                                underlineFocusStyle={styles.focusStyle}
                                                                                floatingLabelFocusStyle={styles.focusTextStyle} />
                                                                            :
                                                                            <TextField
                                                                                // hintText="Answer for Secret Question"
                                                                                hintText={(this.state.secretQuestionCode === "DOB") ? "DD/MM/YYYY" : "Start Typing.."}
                                                                                floatingLabelText="Secret Answer"
                                                                                type="text"
                                                                                id="secretAnswer"
                                                                                name="secretPassword"
                                                                                maxLength="50"
                                                                                className="my-className"
                                                                                onChange={this.handleAnswer}
                                                                                underlineFocusStyle={styles.focusStyle}
                                                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                                            />
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="offset-md-2 col-sm-7 offset-sm-0 text-center margin-capcha">
                                                                        <Recaptcha
                                                                            sitekey="6LeRorofAAAAACriDJ7aN2WI9LOCRz8aN2KzqU3C"
                                                                            render="explicit"
                                                                            verifyCallback={this.verifyCallback}
                                                                            expiredCallback={this.expiredCallback}
                                                                            onloadCallback={callback}
                                                                            ref={e => recaptchaInstance = e}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row input-group" style={{ marginTop: "15px" }} >
                                                                    <div className="col-sm-12 offset-md-2 offset-sm-0" >
                                                                        <label style={{ fontSize: "15px", color: "rgb(66, 62, 62)" }}>
                                                                            User ID to be emailed to:  {emailId || "-"}
                                                                        </label>
                                                                    </div>

                                                                </div>
                                                                <div className="col-md-12 col-sm-12">
                                                                    <div className="row offset-md-2 input-group text-center"  >

                                                                        <RaisedButton
                                                                            label="Go Back To HomePage"
                                                                            // style={styles.button}
                                                                            className="btn-std mt-2 mr-3"
                                                                            backgroundColor="#FFCE39"
                                                                            labelColor="#115876"
                                                                            onClick={this.handleGoback.bind(this)}
                                                                            buttonStyle={{ borderRadius: 50 }}
                                                                            style={{ borderRadius: 50 }}
                                                                        // icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                        />
                                                                        <RaisedButton
                                                                            label="Get User ID"
                                                                            // style={styles.button}
                                                                            className="btn-std mt-2"
                                                                            backgroundColor="#FFCE39"
                                                                            labelColor="#115876"
                                                                            // onClick={this.handelSecretAnswer}
                                                                            onClick={this.otpPopupOpenModal}
                                                                            disabled={this.state.disableduser}
                                                                            buttonStyle={{ borderRadius: 50 }}
                                                                            style={{ borderRadius: 50 }}
                                                                        // icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                        />

                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            default:
                return (
                    <div>Something Went Wrong</div>
                )
        }
    }

    sendUserDetail(userDetail) {
        this.setState({ stepIndex: 1, userDetailState: userDetail });
    }
    handleNext() {

        const { stepIndex } = this.state;

        if (stepIndex < 2) {
            this.setState({ stepIndex: stepIndex + 1 });
        }
    }

    handlePrev() {
        const { stepIndex } = this.state;

        if (stepIndex > 0) {
            this.setState({ stepIndex: stepIndex - 1 });
        }
    }
    handleStep1() {
        this.setState({ stepIndex: 2 });
    }

    render() {
        const { stepIndex } = this.state;

        return (
            <div>
                {this.state.showResetPopup && (
                    <SuccessPopup
                        message={this.state.popupMessage}
                        onClose={() => this.setState({ showResetPopup: false })}
                    />
                )}
                {this.state.otpOpen && (

                    <OtpPopup
                        open={this.state.otpOpen}
                        onClose={this.otpPopupCloseModal}
                        handleRequestOtp={this.handleRequestOtp}
                        onSubmit={this.handleOtpSubmit}
                        loading={this.state.popupLoader}
                    />
                )}
                <div><DefaulNavbar /> </div>
                <div style={{ width: '100%', maxWidth: 700, margin: 'auto', marginTop: "80px" }}>
                    <Stepper activeStep={stepIndex} connector={<ArrowForwardIcon />}>
                        <Step className="step">
                            <StepLabel>Enter Card Number</StepLabel>
                        </Step>

                        <Step className="step">
                            <StepLabel>Verify & Submit</StepLabel>
                        </Step>
                    </Stepper>

                    {this.getStepContent(stepIndex)}


                </div>
            </div>
        );
    }
}


// export default connect(mapStateToProps, mapDispatchToProps)(ForgotUserId);
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ForgotUserId)
);


// WEBPACK FOOTER //
// ./src/components/forgotuserId/forgotUserId.jsx